/**
 * Optimistic UI Models
 * Export all optimistic-related interfaces and utilities
 */
export * from './optimistic-state.interface';
